export const buildDivisionContext = (divisions = []) => {
  return divisions.reduce((context, division) => {
    const divisionId = division.key || division.division_id;
    const divisionName = (division.value || division.division_name || '').trim();

    if (divisionId && divisionName) {
      context[divisionId] = divisionName;
    }

    return context;
  }, {});
};

export const normalizeHitProductId = (hit) => {
  return { ...hit, ext_product_id: hit.objectID };
};

export const resolveDivisionForHit = (hit, divisionContext) => {
  const normalizedHit = normalizeHitProductId(hit);

  if (!divisionContext) {
    return normalizedHit;
  }

  const divisionId = normalizedHit.division_id || normalizedHit.division_ids?.[0];
  const divisionName = divisionId ? divisionContext[divisionId] : null;

  if (!divisionName) {
    return normalizedHit;
  }

  return {
    ...normalizedHit,
    division_id: divisionId,
    division_name: divisionName,
    division_ids: Array.isArray(normalizedHit.division_ids) ? normalizedHit.division_ids : [divisionId],
  };
};

export const expandHitByDivision = (hit, divisionContext, allowedDivisionIdsSet = null) => {
  const normalizedHit = normalizeHitProductId(hit);
  const hasAllowedDivisionFilter = allowedDivisionIdsSet instanceof Set && allowedDivisionIdsSet.size > 0;
  const divisionIds = Array.isArray(normalizedHit.division_ids) && normalizedHit.division_ids.length > 0
    ? Array.from(new Set(normalizedHit.division_ids.filter(Boolean).map((divisionId) => String(divisionId))))
    : (normalizedHit.division_id ? [String(normalizedHit.division_id)] : []);
  const scopedDivisionIds = hasAllowedDivisionFilter
    ? divisionIds.filter((divisionId) => allowedDivisionIdsSet.has(divisionId))
    : divisionIds;

  if (scopedDivisionIds.length === 0) {
    return [resolveDivisionForHit(normalizedHit, divisionContext)];
  }

  return scopedDivisionIds.map((divisionId) => {
    return resolveDivisionForHit({
      ...normalizedHit,
      division_id: divisionId,
      division_ids: scopedDivisionIds,
    }, divisionContext);
  });
};

export const expandHitsByDivision = (hits, divisionContext, allowedDivisionIds = null) => {
  const allowedDivisionIdsSet = Array.isArray(allowedDivisionIds) && allowedDivisionIds.length > 0
    ? new Set(allowedDivisionIds.filter(Boolean).map((divisionId) => String(divisionId)))
    : null;

  return hits.reduce((expandedHits, hit) => {
    return expandedHits.concat(expandHitByDivision(hit, divisionContext, allowedDivisionIdsSet));
  }, []);
};
